var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "600" },
      model: {
        value: _vm.addRoleDialog,
        callback: function ($$v) {
          _vm.addRoleDialog = $$v
        },
        expression: "addRoleDialog",
      },
    },
    [
      _c("custom-dialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s("Role 추가하기") + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: {
                      click: function ($event) {
                        _vm.addRoleDialog = false
                      },
                    },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 pt-2 mb-10",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: { cols: "10", align: "left" },
                              },
                              [_vm._v(" " + _vm._s("Role Group Name") + " ")]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 mt-1",
                                attrs: { cols: "10" },
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.roleGroupName,
                                      expression: "roleGroupName",
                                    },
                                  ],
                                  staticClass: "member_input",
                                  attrs: { readonly: "" },
                                  domProps: { value: _vm.roleGroupName },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.roleGroupName = $event.target.value
                                    },
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 mt-5",
                                attrs: { cols: "10", align: "left" },
                              },
                              [_vm._v(" " + _vm._s("Role List") + " ")]
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 mt-1",
                                staticStyle: { width: "100%" },
                                attrs: { cols: "10" },
                              },
                              [
                                _c("v-select", {
                                  attrs: {
                                    "background-color": "#272727",
                                    dark: "",
                                    items: _vm.roleList,
                                    dense: "",
                                    "hide-details": "",
                                    outlined: "",
                                    "item-text": "name",
                                    "item-value": "key",
                                  },
                                  model: {
                                    value: _vm.selectedRoleKey,
                                    callback: function ($$v) {
                                      _vm.selectedRoleKey = $$v
                                    },
                                    expression: "selectedRoleKey",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-row",
                          {
                            staticClass: "ma-0 pa-0 mt-5 pb-2",
                            attrs: { align: "center", justify: "center" },
                          },
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  id: "grey_btn",
                                  width: "8rem",
                                  height: "2rem",
                                },
                                on: {
                                  click: function ($event) {
                                    _vm.addRoleDialog = false
                                  },
                                },
                              },
                              [_vm._v(_vm._s("취소"))]
                            ),
                            _c(
                              "v-btn",
                              {
                                staticClass: "ma-0 pa-0 ml-2",
                                attrs: {
                                  id: "blue_btn",
                                  loading: _vm.loading,
                                  width: "8rem",
                                  height: "2rem",
                                },
                                on: { click: _vm.addRole },
                              },
                              [_vm._v(_vm._s("확인"))]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }